var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("div", { staticClass: "wf-page-controls" }, [
        _c(
          "button",
          {
            staticClass: "d-inline-flex btn btn-sm btn-light",
            attrs: { type: "button", "aria-label": "Back" },
            on: { click: _vm.handleBack }
          },
          [
            _c("span", {
              staticClass:
                "png-icon png-icon-icons-glyph--k-arrow-left-sm d-lg-inline"
            }),
            _vm._v(" "),
            _c("span", { staticClass: " d-lg-inline pl-1" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$resourceString["common.Button.ReturnBack.Label"]
                  ) +
                  "\n          "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "wf-page-controls-items" }, [
          _c(
            "div",
            {
              staticClass:
                "wf-page-control-item wf-page-control-item-current-refinements"
            },
            [_c("pc-vt-search-current-filters")],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          attrs: { id: "outer-wrapper" },
          on: {
            mousedown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "left", 37, $event.key, [
                  "Left",
                  "ArrowLeft"
                ])
              ) {
                return null
              }
              if ("button" in $event && $event.button !== 0) {
                return null
              }
              return _vm.unmouseStuff($event)
            }
          }
        },
        [
          _c("div", { attrs: { id: "outer-container" } }, [
            _c(
              "header",
              {
                staticClass: "my-4",
                attrs: { "data-html2canvas-ignore": "true" }
              },
              [
                _c("div", { staticClass: "virtual-tray-search" }, [
                  _c(
                    "div",
                    { staticClass: "input-group border border-light mb-3" },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn bg-white px-1",
                            attrs: { tabindex: "-1", type: "submit" }
                          },
                          [
                            _c("Icon", {
                              attrs: {
                                icon: "simple-line-icons:magnifier",
                                color: "#B6BBCF",
                                width: "15"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "form-control border-0",
                        attrs: {
                          type: "search",
                          placeholder: "search collection, style, color, #"
                        },
                        domProps: { value: _vm.searchTerm },
                        on: { input: _vm.searchInput }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row w-100 px-3" }, [
                  _c("div", { staticClass: "col-9 px-0" }, [
                    _c(
                      "div",
                      { staticClass: "row justify-content-md-start d-flex" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "hide-on-mobile-tablet",
                            class: !_vm.trayId
                              ? "col-lg-3 col-md-6 my-1"
                              : "col-lg-3 col-md-auto my-1"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-outline-primary vt-dwonload-spec-hover h-100 w-100",
                                on: { click: _vm.downloadTrayImage }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "virtualtray.download.tray"
                                      ]
                                    ) +
                                    "\n                  "
                                ),
                                _c("span", {
                                  staticClass:
                                    "png-icon png-icon-icons-glyph--g-btn-download"
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            class: !_vm.trayId
                              ? "col-lg-3 col-md-5 my-1"
                              : "col-lg-3 col-md-6 my-1"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-outline-primary h-100 w-100",
                                on: { click: _vm.downloadSpecs }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "virtualtray.download.specs"
                                      ]
                                    ) +
                                    "\n                  "
                                ),
                                _c("span", {
                                  staticClass:
                                    "png-icon png-icon-icons-glyph--g-btn-download"
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isAdminMode
                          ? _c(
                              "div",
                              {
                                class: !_vm.trayId
                                  ? "col-lg-3 col-md-5 my-1"
                                  : "col-lg-3 col-md-6 my-1"
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-primary h-100 w-100",
                                    on: { click: _vm.downloadTrayJson }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$resourceString[
                                            "Virtualtray.Download.Tray.Json"
                                          ]
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            class: !_vm.trayId
                              ? "col-lg-3 col-md-5 my-1"
                              : "col-lg-3 col-md-5 my-1"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-outline-primary h-100 w-100",
                                class: { disabled: _vm.isDisabled },
                                attrs: { disabled: _vm.isDisabled },
                                on: { click: _vm.shareTray }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "virtualtray.Sharetray.Header"
                                      ]
                                    ) +
                                    "\n                  "
                                ),
                                _c("span", {
                                  staticClass:
                                    "png-icon png-icon-icons-glyph--g-share"
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            class: !_vm.trayId
                              ? "col-lg-3 col-md-5 my-1"
                              : "col-lg-3 col-md-6 my-1",
                            on: { click: _vm.saveTray }
                          },
                          [
                            _c(
                              "button",
                              {
                                ref: "saveTrayHref",
                                staticClass:
                                  "btn btn-outline-primary h-100 w-100",
                                attrs: { href: _vm.saveTrayHref }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "virtualtray.Savetray.Header"
                                      ]
                                    ) +
                                    "\n                  "
                                ),
                                _c(
                                  "svg",
                                  {
                                    staticClass: "ml-2",
                                    staticStyle: {
                                      height: "26px",
                                      width: "22px"
                                    },
                                    attrs: {
                                      fill: "darkgray",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      viewBox: "0 0 448 512"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M48 96V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V170.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm80-16v80H272V80H128zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-3 col-12 col-md-3 my-1" }, [
                    _c("div", { staticClass: "row justify-content-lg-end" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-auto order-samples w-auto ",
                          class: { disabled: _vm.OrderSampleEnabled },
                          style: {
                            "pointer-events": _vm.OrderSampleEnabled
                              ? "none"
                              : "auto",
                            "background-color": _vm.OrderSampleEnabled
                              ? "#ccc"
                              : ""
                          },
                          on: { click: _vm.addToBasketClick }
                        },
                        [
                          _c("span", {
                            staticClass:
                              "png-icon png-icon-icons-glyph--ko-my-basket mr-2",
                            staticStyle: { cursor: "pointer" },
                            attrs: { href: "#order" }
                          }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "pt-1 text-light text-decoration-none",
                              attrs: { href: "#order" }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$resourceString[
                                      "virtualtray.add.tray.to.basket"
                                    ]
                                  )
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "mt-3 start-over text-left text-nowrap"
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "text-underline",
                              attrs: { role: "button" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.openStartOverModal($event)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$resourceString[
                                      "virtualtray.start.over"
                                    ]
                                  ) +
                                  "\n                  "
                              ),
                              _c("Icon", {
                                attrs: { icon: "dashicons:image-rotate" }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex mt-1 mb-4 mr-4" }, [
              _c(
                "div",
                {
                  staticClass: "wf-product-category-sidebar-desktop",
                  attrs: { "data-html2canvas-ignore": "true" }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-white shadow-sm w-100 mt-3 btn-xs shadow-sm",
                      attrs: { href: "/Account/MyTrays?tab=premix" }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$resourceString["virtualtray.premixes.trays"]
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-white shadow-sm w-100 btn-xs mt-3 shadow-sm",
                      on: { click: _vm.openFiltersModal }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$resourceString["virtualtray.all.filters"])
                        )
                      ]),
                      _vm._v(" "),
                      _c("Icon", {
                        attrs: {
                          icon: "ion:options-outline",
                          rotate: 2,
                          height: "1.5em",
                          "aria-hidden": "true"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "results-container mt-4" },
                    [
                      _c("pc-infinity-hits", {
                        ref: "childref",
                        attrs: { "data-html2canvas-ignore": "true" },
                        on: { onResultClick: _vm.processSlideEvent }
                      }),
                      _vm._v(" "),
                      _vm.showLoadMore
                        ? _c("pc-load-more", {
                            attrs: { "load-more": _vm.onLoadMore }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "w-100 d-flex justify-content-between align-items-center"
                },
                [
                  _c("div", { staticClass: "bottom-container" }, [
                    _c(
                      "div",
                      [
                        _vm.modalShownBool && !_vm.showLoaderOnTrayZone
                          ? _c(
                              "div",
                              { staticClass: "welcome-msg welcome-msg-sm" },
                              [_c("pc-welcome-msg")],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showLoaderOnTrayZone
                          ? _c("pc-load-more", {
                              attrs: { "load-more": function() {} }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.showLoaderOnTrayZone
                          ? _c("pc-tray-tiles", {
                              on: {
                                startDrag: _vm.startDrag,
                                trayDeleteItem: _vm.trayDeleteItem
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "modal",
            { attrs: { name: "remove-item-confirm-modal", height: "auto" } },
            [
              _c("pc-confirm-modal", {
                attrs: {
                  header:
                    _vm.$resourceString[
                      "virtualtray.delete.item.confirm.header"
                    ],
                  subheader:
                    _vm.$resourceString[
                      "virtualtray.delete.item.confirm.subheader"
                    ],
                  close: _vm.closeRemoveModal,
                  confirm: _vm.confirmRemove,
                  adaptive: true,
                  hidePopup: true
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "modal",
            {
              attrs: {
                name: "start-over-confirm-modal",
                height: "200",
                adaptive: true
              }
            },
            [
              [
                _c("pc-confirm-modal", {
                  attrs: {
                    header:
                      _vm.$resourceString[
                        "virtualtray.start.over.confirm.header"
                      ],
                    subheader:
                      _vm.$resourceString[
                        "virtualtray.start.over.confirm.subheader"
                      ],
                    close: _vm.closeStartOverModal,
                    confirm: _vm.confirmStartOver,
                    hidePopup: false
                  }
                })
              ]
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "modal",
            {
              attrs: {
                name: "premixes-confirm-modal",
                height: "200",
                adaptive: true
              }
            },
            [
              _c("pc-confirm-modal", {
                attrs: {
                  header:
                    _vm.$resourceString["virtualtray.replace.confirm.header"],
                  subheader:
                    _vm.$resourceString[
                      "virtualtray.replace.confirm.subheader"
                    ] +
                    " " +
                    _vm.premix.name +
                    "?",
                  close: _vm.closePremixesConfirmModal,
                  confirm: _vm.processPremixClick,
                  hidePopup: false
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "modal",
            {
              attrs: {
                name: "add-to-cart-confirm-modal",
                height: "350",
                adaptive: true
              }
            },
            [
              _c("pc-confirm-modal", {
                attrs: {
                  header:
                    _vm.$resourceString[
                      "virtualtray.add.to.basket.confirm.header"
                    ],
                  subheader:
                    _vm.$resourceString[
                      "virtualtray.add.to.basket.confirm.subheader"
                    ],
                  close: _vm.closeAddToBasketConfirm,
                  confirm: _vm.addToBasket,
                  hidePopup: false
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "modal",
            {
              attrs: {
                name: "too-much-items-alert-modal",
                height: "250",
                adaptive: true
              }
            },
            [
              _c("pc-alert-modal", {
                attrs: {
                  header:
                    _vm.$resourceString[
                      "virtualtray.too.much.items.alert.header"
                    ],
                  subheader:
                    _vm.$resourceString[
                      "virtualtray.too.much.items.alert.subheader"
                    ],
                  close: _vm.closeTooMuchAlertModal
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "modal",
            {
              attrs: {
                name: "no-items-for-cart-alert-modal",
                height: "200",
                adaptive: true
              }
            },
            [
              _c("pc-alert-modal", {
                attrs: {
                  header:
                    _vm.$resourceString["virtualtray.no.items.alert.header"],
                  subheader:
                    _vm.$resourceString["virtualtray.no.items.alert.subheader"],
                  close: _vm.closeNoItemsForCart
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "modal",
            {
              attrs: {
                name: "no-items-to-download-modal",
                height: "200",
                adaptive: true
              }
            },
            [
              _c("pc-alert-modal", {
                attrs: {
                  header:
                    _vm.$resourceString["virtualtray.no.items.alert.header"],
                  subheader:
                    _vm.$resourceString[
                      "virtualtray.no.items.to.download.subheader"
                    ],
                  close: _vm.closeNoItemsForDownload
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "modal",
            {
              attrs: {
                name: "download-specs-modal",
                "data-html2canvas-ignore": "true",
                adaptive: true
              }
            },
            [_c("pc-download-specs-modal")],
            1
          ),
          _vm._v(" "),
          _c(
            "modal",
            {
              attrs: {
                "max-height": 450,
                height: "500",
                name: "save-tray-modal",
                "data-html2canvas-ignore": "true",
                scrollable: true,
                adaptive: true
              }
            },
            [
              _c("pc-vt-save-tray-modal", {
                attrs: {
                  boardDetails: _vm.boardDetails,
                  trayId: _vm.trayId,
                  isAdminMode: _vm.user ? _vm.user.isAdmin : false,
                  user: _vm.user ? _vm.user.user : null
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "modal",
            {
              attrs: {
                height: "650",
                name: "share-tray-modal",
                "data-html2canvas-ignore": "true",
                adaptive: true,
                scrollable: true
              }
            },
            [
              _c("pc-vt-share-tray-modal", {
                attrs: { userEmail: _vm.user.user ? _vm.user.user.email : "" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "modal",
            { attrs: { height: "650", name: "upload-image-modal" } },
            [_c("pc-vt-upload-image-modal", { attrs: { user: _vm.user } })],
            1
          ),
          _vm._v(" "),
          _c(
            "modal",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isFiltersModalOpened,
                  expression: "isFiltersModalOpened"
                }
              ],
              attrs: {
                adaptive: true,
                name: "filters-modal",
                scrollable: true,
                height: "500",
                "max-height": 600,
                "data-html2canvas-ignore": "true"
              },
              on: { "before-close": _vm.hideFiltersModal }
            },
            [
              _c(
                "div",
                { staticClass: "p-3 ml-3 mt-3 pr-5 filters-wrapper" },
                [_c("pc-vt-side-filters")],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "wf-modal-button-close btn button-full",
                  attrs: { type: "button" },
                  on: { click: _vm.closeFiltersModal }
                },
                [
                  _c("span", {
                    staticClass: "png-icon png-icon-icons-symbols--k-txtclose",
                    attrs: { "aria-label": "Close modal" }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "modal",
            {
              staticClass: "premixes-modal-z-index",
              attrs: {
                adaptive: true,
                name: "premixes-modal",
                width: "700",
                height: "500",
                "data-html2canvas-ignore": "true",
                scrollable: true
              }
            },
            [
              _c("pc-premixes-modal", {
                on: { onPremixClick: _vm.confirmReplaceToPremix }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "wf-modal-button-close btn button-full",
                  attrs: { type: "button" },
                  on: { click: _vm.closePremixesModal }
                },
                [
                  _c("span", {
                    staticClass: "png-icon png-icon-icons-symbols--k-txtclose",
                    attrs: { "aria-label": "Close modal" }
                  })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "modal",
            { attrs: { name: "redirect-confirm-modal", height: "auto" } },
            [
              _c("pc-redirect-confirm-modal", {
                attrs: {
                  header:
                    _vm.$resourceString[
                      "accounts.Virtualtray.Redirect.Confirm.HeaderFirst"
                    ],
                  subheader:
                    _vm.$resourceString[
                      "accounts.Virtualtray.Redirect.Confirm.Header"
                    ],
                  close: _vm.closeRedirectModal,
                  adaptive: true,
                  hidePopup: true
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("pc-vt-download")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }